/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Icon = ({ color, flipY, flipX, className, width, height, children }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    sx={{
      color,
      transform: `${flipX ? `scaleX(-1)` : ``} ${flipY ? `scaleY(-1)` : ``}`,
    }}
    className={className}
  >
    {children}
  </svg>
)

Icon.defaultProps = {
  color: "primary",
  flipX: false,
  flipY: false,
}

Icon.propTypes = {
  color: PropTypes.string,
  flipY: PropTypes.bool,
  flipX: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
}

export default Icon
